var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M43.062,43.615C47.47,44.163 49.941,49.519 46.96,53.352C46.878,53.459 46.795,53.566 46.713,53.673C30.055,75.47 27.106,106.876 40.382,131.407C55.141,158.677 87.724,175.061 119.288,169.43C137.78,166.131 154.783,155.721 165.984,140.513C166.956,139.193 168.003,137.014 168.003,137.014C164.606,136.601 161.116,137.832 157.489,138.156C144.006,139.361 130.124,136.951 117.922,131.22C113.403,129.098 113.187,122.002 118.044,120.266C121.221,119.131 124.914,121.751 129.199,123.24C139.837,126.936 151.351,127.702 162.541,125.713C163.956,125.475 164.128,125.47 164.859,125.403C170.741,124.862 177.554,126.914 179.389,133.071C181.126,138.903 177.215,145.217 173.409,149.99C155.184,172.847 124.713,185.368 95.077,181.586C55.893,176.587 21.954,142.05 20.237,101.096C19.416,81.499 25.736,61.655 37.755,46.195C39.073,44.498 40.792,43.557 43.062,43.615ZM81.148,17.734C85.192,17.843 89.164,19.834 91.042,23.449C94,29.142 90.532,36.212 88.485,42.191C80.857,64.475 87.489,90.761 104.133,107.492C104.133,107.492 106.693,111.099 105.267,114.104C103.54,117.742 98.403,118.357 94.924,114.757C74.992,94.135 67.616,62.211 78.958,34.399C79.627,32.759 80.461,31.17 80.649,29.444L76.479,30.586C73.097,31.564 71.921,30.488 70.659,29.306C67.627,26.464 68.907,20.975 73.457,19.246C75.747,18.376 78.163,17.794 80.621,17.734C80.885,17.732 80.884,17.732 81.148,17.734Z",
    style: {
      fill: "rgb(41,45,50)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.9c47bffd.svg";
export { ForwardRef as ReactComponent };